import { Injectable } from '@angular/core';
import { Confirmation, ConfirmationService, MessageService } from 'primeng/api';
import { GLOBAL_CONFIRMATION_KEY, GLOBAL_TOAST_KEY } from '@core/constants';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
  ) {}

  confirm(options: Confirmation) {
    return new Promise((resolve, reject) => {
      this.confirmationService.confirm({
        key: GLOBAL_CONFIRMATION_KEY,
        ...options,
        accept: resolve,
        reject: () => reject(),
      })
    })
  }

  showSuccess(message?: string, summary?: string): void {
    this.messageService.add({
      key: GLOBAL_TOAST_KEY,
      severity: 'success',
      summary: summary || 'Success',
      detail: message || 'Operation completed successfully',
      life: 5000,
    });
  }

  showWarning(message?: string, summary?: string): void {
    this.messageService.add({
      key: GLOBAL_TOAST_KEY,
      severity: 'warn',
      summary: summary || 'Warning',
      detail: message,
      life: 5000,
    });
  }

  showError(message?: string, title?: string): void {
    this.messageService.add({
      key: GLOBAL_TOAST_KEY,
      severity: 'error',
      summary: title || 'Error',
      detail: message || 'Something went wrong. Please try again or contact Portal support',
      life: 5000,
    });
  }

  showInfo(message: string, title?: string): void {
    this.messageService.add({
      key: GLOBAL_TOAST_KEY,
      severity: 'info',
      summary: title || 'Info',
      detail: message,
      life: 5000,
    })
  }

  showStickyError(message: string, title?: string): void {
    this.messageService.add({
      key: GLOBAL_TOAST_KEY,
      severity: 'error',
      summary: title || 'Error',
      detail: message,
      sticky: true,
    });
  }
}
